import { Box, Heading, Icon, Text, VStack } from "@chakra-ui/react"
import { FaDiagramProject } from "react-icons/fa6"
import AssignAssetsButton from "./AssignAssetsButton"

interface AssignAssetsBlankSlateProps {
  onAssignAssets: () => void
}

/**
 * Blank slate shown in place of the canvas when a system has no assigned
 * assets yet. Assignment is independent of the layout lock — this state
 * (and its "Assign assets" CTA) is shown regardless of isEditMode.
 */
const AssignAssetsBlankSlate = ({ onAssignAssets }: AssignAssetsBlankSlateProps) => {
  return (
    <Box
      width="100%"
      height="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
      minHeight="400px"
      data-testid="assign-assets-blank-slate"
    >
      <VStack gap={4} textAlign="center" px={6}>
        <Icon as={FaDiagramProject} boxSize="50px" color="blue.500" />
        <Heading as="h3" size="md">
          No assets assigned to this system
        </Heading>
        <Text color="fg.muted" maxWidth="360px">
          Please add assets to this system to get started
        </Text>
        <AssignAssetsButton onClick={onAssignAssets} />
      </VStack>
    </Box>
  )
}

export default AssignAssetsBlankSlate
